import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import {Button, AppBar, Toolbar} from '@mui/material';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
    },
    paper: {
        padding: 8
    },
    appbar: {
        flexGrow: 1,
        top: 5,
        zIndex: 999,
        position: 'relative'
    },
    appbarFixed: {
        flexGrow: 1,
        top: "auto",
        bottom: 0,
        zIndex: 999,
        position: "fixed"
    },
    toolbar: {
          // border: "1px solid #dedede",
          // backgroundColor: "#eee"
    },
    toolbarMinimal: {
      display: "flex",
      justifyContent: "flex-end"
    },
    actionButton: {
        width: 120,
        marginLeft: theme.spacing(),
        "&:first-child": {
            marginLeft: "0px !important;",
        }
    }, 
    getNextButtom: {
      width: 120,
      paddingLeft: 2,
      marginLeft: theme.spacing(),
      "&:first-child": {
          marginLeft: "0px !important;",
      }
  }, 
  getNextIcon: {
    marginRight: 5,
    fontSize: "inherit"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  actions: any;
	handleAction: (actionRequest: any)=>void;
	disabled: boolean;
  disableGutters?: boolean;
  position?: 'absolute' | 'fixed' | 'relative' | 'static' | 'sticky';
  // Variant currntly only supports minimal which will not position buttons automatically and will not set the backgroud.
  variant?: string
  getNextEnabled?: boolean;
}

type State = {
	
};

class PortalTaskActions extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
        super(props, {});
		this.state = {
			
		};
	}

	componentDidMount() {
       
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {

	}

	handleAction = (action: any) => {
        if (this.props.handleAction) {
            this.props.handleAction(action)
        }
    }
    
    getButtonColor = (action: any) => {
        if (action.options && action.options.buttonColor) {
            return action.options.buttonColor
        }
        return "default"
    }

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		const { disableGutters, position, variant, getNextEnabled} = this.props;
    
        var actions = Array<any>()
        actions = this.props.actions.map((a: any, idx)=>{
          if (a.action == "Get Next") {
            return (
              <Button
                key={idx}
                // variant="contained"
                onClick={this.handleAction.bind(this, a)}
                disabled={this.props.disabled}
                color={this.getButtonColor(a)}
                className={classes.getNextButtom}
              >
                {getNextEnabled ? <RadioButtonChecked className={classes.getNextIcon}/> : <RadioButtonUnchecked className={classes.getNextIcon}/>}{a.action}
              </Button>
            )
          } else {
            return (
              <Button
                key={idx}
                variant="contained"
                onClick={this.handleAction.bind(this, a)}
                disabled={this.props.disabled}
                color={this.getButtonColor(a)}
                className={classes.actionButton}
              >
                {a.action}
              </Button>
            )
          }
            
        })  

        // If the first action is "Cancel" or "Close", left justify it on the actionbar, everything else is right justified. 
        if (this.props.actions.length > 0 && (this.props.actions[0].action == "Cancel" || this.props.actions[0].action == "Close") && variant != "minimal") {
            // actions.splice(1, 0, (<div key={actions.length + 1} style={{flex:1}}></div>))
        }

    var appBarStyle = classes.appbar
    if (position=="fixed") {
      appBarStyle = classes.appbarFixed
    }

    let tbClass = classes.toolbar
    if (variant == "minimal") {
      tbClass = classes.toolbarMinimal
    }

		return (
			<AppBar elevation={0} position={position} className={appBarStyle}>
          <Toolbar style={{position: "absolute", right: 0}} disableGutters={disableGutters} className={tbClass}>
            <div style={{flex:1}}></div>
              {actions}
          </Toolbar>
      </AppBar>
    );
	}
}
export default withStyles(styles)(PortalTaskActions);

